import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.95 14.95a7 7 0 10-9.9-9.9 7 7 0 009.9 9.9zm-.762-.762a5.923 5.923 0 11-8.376-8.376 5.923 5.923 0 018.376 8.376zm-7.36-4.6h2.506V7.081c0-.264.191-.484.442-.53l.097-.009c.297 0 .539.242.539.539l-.001 2.508h2.508a.538.538 0 010 1.076h-2.508v2.508c0 .264-.19.484-.441.53l-.097.008a.538.538 0 01-.538-.538l-.001-2.507H6.827a.538.538 0 010-1.078z" })
});
export default SvgPlusCircle;
